import React, { Suspense, useEffect, useState } from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import Cookies from "../components/cookies/cookies";
import HeaderBar from "../components/header/header-bar";
import Footer from "../components/footer/footer";

import AppRouter from "../routes";
import SiteAlerts from "../components/re-usable/alerts/site-alerts";
import LoadingComp from "../components/re-usable/loading/loading";
import { RootState, useAppDispatch } from "../redux/store";
import { retrieveNotification } from "../redux/slice/notification-slice";
import useRawRedirectUrls from "../hooks/useRawRedirectUrls";

const RedirectUrlAllPage = React.lazy(() => import("../pages/redirects/redirect-all"));

type RedirectUrlType = {
  oldUrl: string;
  newUrl: string;
};

const DefaultLayout = () => {
  const dispatch = useAppDispatch();

  const { notificationData } = useSelector((state: RootState) => state.notification);
  const allRedirectUrls = useSelector((state: RootState) => state.allRedirectUrls);
  const { redirectUrls } = useRawRedirectUrls();
  const [redirectUrlList, setRedirectUrlList] = useState<RedirectUrlType[] | null>(redirectUrls?.redirectList ?? null);

  useEffect(() => {
    dispatch(retrieveNotification());
  }, [dispatch]);

  useEffect(() => {
    if (redirectUrls === null && allRedirectUrls.data.urlRedirectLists !== undefined) {
      setRedirectUrlList(allRedirectUrls.data.urlRedirectLists);
    }
  }, [allRedirectUrls.data]);

  if (redirectUrlList === null) return <LoadingComp />;

  return (
    <>
      <Cookies />
      <HeaderBar />
      <div className="container sitealert">
        {!notificationData[0]?.notificationMenuData[0]?.rapsUpdates.trim().endsWith('-->') &&
          <SiteAlerts alertData={notificationData[0]?.notificationMenuData[0]?.rapsUpdates}></SiteAlerts>}
      </div>
      <Suspense fallback={<LoadingComp />}>
        <Routes>
          {redirectUrlList !== null && redirectUrlList.map((route: RedirectUrlType, index: number) => {
            return (
              <Route key={index} path={route.oldUrl}
                element={
                  route.newUrl.match(/^(https?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/) ? (
                    <RedirectUrlAllPage redirectUrl={route.newUrl} />) : (<Navigate to={route.newUrl} replace />)
                } />
            );
          })}
          {AppRouter.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
          })}
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

export default DefaultLayout;
